import { render, staticRenderFns } from "./need-feedback.vue?vue&type=template&id=733b9fe5&scoped=true&"
import script from "./need-feedback.vue?vue&type=script&lang=js&"
export * from "./need-feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733b9fe5",
  null
  
)

export default component.exports